import { Box } from '@chakra-ui/layout'
import { Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral'
import type { AnalyticsAPIResponse } from '../../interfaces'
import ScrollableTable from './ScrollableTable'

interface Props {
  data: AnalyticsAPIResponse
  showBandwidth: Boolean
}

const TopDevicesTable = ({
  data,
  showBandwidth,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const deviceTypeData = data.deviceDistribution

  if (!deviceTypeData || !Object.keys(deviceTypeData).length) {
    return <Box>{t('no_data_available', 'No Data Available')}</Box>
  }

  const tableRows = deviceTypeData.map(item => {
    if (!item.name || !item.count) {
      return null
    }
    let name = ''
    try {
      name = decodeURI(item.name)
    } catch (err) {
      name = item.name
    }

    return (
      <Tr key={item.name}>
        <Td>{name}</Td>
        <Td>
          {showBandwidth === true
            ? `${numeral(item.count)
                .format('0.0 a')
                .toUpperCase()} requests (${numeral(item.bandwidth)
                .format('0.0 ib')
                .replace('i', '')})`
            : `${numeral(item.count).format('0.0 a').toUpperCase()} requests`}
        </Td>
        <Td>
          {item.bot === 1 ? t('bot', 'Bot') : t('user_device', 'User device')}
        </Td>
      </Tr>
    )
  })

  return (
    <ScrollableTable>
      <Thead>
        <Tr>
          <Th>{t('device', 'Device')}</Th>
          <Th>{t('usage', 'Usage')}</Th>
          <Th>{t('device_type', 'Device type')}</Th>
        </Tr>
      </Thead>
      <Tbody>{deviceTypeData.length ? tableRows : null}</Tbody>
    </ScrollableTable>
  )
}

export default TopDevicesTable
